// src/components/store/sections/newsletter/NewsletterV10BentosignupIndigoPulse.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV10BentosignupIndigoPulse(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={10}
      archKey="bento_signup"
      archLabel="Bento Multi-Tile Signup"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
